import service from '@/store/services/personal-tokens-service';

export default {
    namespaced: true,
    
    state: {
        list: {},
        personalToken: {},
        meta: {},
        alert: {
            id: null,
            message: '',
            type: "warning"
        },
    },

    getters: {
        list: state => state.list,
        listTotal: state => state.meta.page.total,
        personalToken: state => state.personalToken,
        alert: state => state.alert,
    },

    actions: {
        list({ commit, dispatch }, params) {
            return service.list(params)
                .then(({ list, meta }) => {
                    commit('SET_LIST', list);
                    commit('SET_META', meta);
                });
        },

        add({ commit, dispatch }, params) {
            return service.add(params)
                .then((personalToken) => { 
                    commit('SET_RESOURCE', personalToken); 
                    return personalToken; 
                });
        },

        destroy({ commit, dispatch }, params) {
            return service.destroy(params);
        },

        setAlert({ commit, dispatch }, alert) {
            setTimeout(()=>{
                alert.message = '';
                alert.id = null;
            }, 8000)
            commit('SET_ALERT', alert);
        },
    },

    mutations: {
        SET_LIST: (state, list) => {
            state.list = list;
        },
        SET_RESOURCE: (state, personalToken) => {
            state.personalToken = personalToken;
        },
        SET_META: (state, meta) => {
            state.meta = meta;
        },
        SET_ALERT: (state, alert) => (state.alert = alert),
    }
};